<script>
export let color = "is-default";
</script>
<style>
.loader-svelte{
    background: transparent !important;
    border: 0 !important;
}
</style>
<div class="field">
    <div class="control">
        <div class="buttons is-grouped is-centered">
            <button type="button" class="is-loading button loader-svelte {color} is-large"></button>
        </div>
    </div>
</div>